import React from 'react';
import { FlatIcon } from '../../Icons/FlatIcon';
import useStyle from './createNewClasseButton.style';

interface CreateNewClasseButtonProps {
  onClick: () => void;
}
export const CreateNewClasseButton = ({
  onClick
}: CreateNewClasseButtonProps) => {
  const classes = useStyle();
  return (
    <div className={classes.container} onClick={onClick}>
      <p>Ajouter une classe</p>
      <FlatIcon icon={'RoundedPlus'} />
    </div>
  );
};
